import { fetch } from '@maxtropy/components';

export interface DistributionCabinetProps {
  id: number;
  name: string;
  ouId: number;
}

export const getDistributionCabinetList = () =>
  fetch<{ list: DistributionCabinetProps[] }>(
    `/api/v2/distribution-cabinet/list`,
    {
      method: 'POST',
    },
    true
  ).then(res => res.list ?? []);
